import {httpService} from "@/modules/common/services";
import {frontageApiService} from "@/plugins/frontage-api";

const list = async (options = {}) => {
  const res = await httpService.get(`documents`, options);
	if (res.status === "Error") {
		return {error: res.message};
	} else {
		return {documents: res}
  }
}

const newDocument = async (client, isAttachmentVersion) => {
  return frontageApiService.get('new-document',{client: client, frameId: 'vue_wizard_iframe', isAttachmentVersion: isAttachmentVersion})
}

export default {
  list,
  newDocument
}
